// format(week.endDate as Date, 'dd/MM/yyyy')

import moment from 'moment';

export const formatDate = (date: Date, mFormat: string): string => moment(date).format(mFormat);

export const getMonthNumber = (date: Date): number => moment(date).month() + 1;

export const getYearNumber = (date: Date): number => moment(date).year();
